import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { cities } from "constants/apiUrls";

const cityListApi = createApi({
  reducerPath: "cityList",
  baseQuery: fetchBaseQuery({ baseUrl: "" }),
  endpoints: (builder) => ({
    cityList: builder.query<
      PaginatedResonse<CountryType>,
      { countryCode: string; stateCode: string }
    >({
      query: (arg) => {
        const { stateCode, countryCode } = arg;
        const token = localStorage.getItem("token");
        const mandatoryHeaders: any = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
        };

        // Add authorization if token exists
        if (token) {
          try {
            mandatoryHeaders.Authorization = `Bearer ${JSON.parse(token)}`;
          } catch (e) {
            // Failed to parse token
          }
        }

        return {
          url: cities(countryCode, stateCode),
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useCityListQuery, useLazyCityListQuery } = cityListApi;
export default cityListApi;
